import logo from '../images/logo.png';
import LazyLoad from 'react-lazy-load';

export default React => props => {
  return (<header>
    <nav>
      <a href="#home" title="" className="logo">
        <LazyLoad>
          <img src={logo} alt="Logo Productora de Nuez SPR de RI" className="logo" />
        </LazyLoad>
      </a>
      <ul>
        <li><a href="#home" title="">Inicio</a></li>
        <li><a href="#about" title=""><span className="lg">Acerca de </span>Nosotros</a></li>
        <li><a href="#services" title="">Servicios</a></li>
        <li><a href="#products" title="">Productos</a></li>
        <li><a href="#contact" title="">contacto</a></li>
      </ul>
    </nav>
  </header>);
}



// WEBPACK FOOTER //
// ./src/components/Header.js